export interface Unit {
  name: string;
  key: string;
  short?: string;
  long?: string;
  symbol?: string;
}

export type UnitStyle = keyof Unit;

export interface UnitMapping {
  [unit: string]: string;
}

export const units: { [key: string]: Unit } = {
  '1': {
    name: 'absolut',
    key: '1',
    short: '',
    long: '',
    symbol: '',
  },
  '3': {
    name: '%',
    key: '3',
    short: '%',
    long: '%',
    symbol: '%',
  },
  '4': {
    name: 'm²',
    key: '4',
    short: 'm²',
    long: 'm²',
    symbol: 'm²',
  },
  '5': {
    name: 'km²',
    key: '5',
    short: 'km²',
    long: 'km²',
    symbol: 'km²',
  },
  '6': {
    name: 'Tage',
    key: '6',
    short: 'Tage',
    long: 'Tage',
    symbol: 'Tage',
  },
  '7': {
    name: '€',
    key: '7',
    short: '€',
    long: '€',
    symbol: '€',
  },
  '8': {
    name: '€ je Einwohner',
    key: '8',
    short: '€/Ew',
    long: '€ je Einwohner',
    symbol: '€/Ew',
  },
  '9': {
    name: '€ je m²',
    key: '9',
    short: '€/m²',
    long: '€ je m²',
    symbol: '€/Ew',
  },
  '10': {
    name: 'je 1.000 Einwohner',
    key: '10',
    short: 'je 1k Ew',
    long: 'je 1.000 Einwohner',
    symbol: '',
  },
  '11': {
    name: 'je 10.000 Einwohner',
    key: '11',
    short: 'je 10k Ew',
    long: 'je 10.000 Einwohner',
    symbol: '',
  },
  '12': {
    name: 'je 100.000 Einwohner',
    key: '12',
    short: 'je 100k Ew',
    long: 'je 100.000 Einwohner',
    symbol: '',
  },
  '13': {
    name: 'km² je 1.000 Einwohner',
    key: '13',
    short: 'km²',
    long: 'km² je 1.000 Einwohner',
    symbol: 'km²',
  },
  '14': {
    name: 'l je Einwohner am Tag',
    key: '14',
    short: 'l/Ew',
    long: 'Liter je Einwohner am Tag',
    symbol: 'l/Ew',
  },
  '15': {
    name: 't je Einwohner',
    key: '15',
    short: 't/Ew',
    long: 'Tonnen je Einwohner',
    symbol: 't/Ew',
  },
  '16': {
    name: 'Jahre',
    key: '16',
    short: 'Jahre',
    long: 'Jahre',
    symbol: 'Jahre',
  },
  '17': {
    name: 'Einwohner je km²',
    key: '17',
    short: 'Ew/km²',
    long: 'Einwohner/km²',
    symbol: 'Ew/km²',
  },
  '99': {
    name: 'kategorial',
    key: '99',
    short: 'ktg',
    long: '',
    symbol: '',
  },
};
export const unitMapping: UnitMapping = {
  'm²': '4',
  m2: '4',
  '%': '3',
  km2: '5',
  'km²': '5',
  Tage: '6',
  '€': '7',
  '€ je Einwohner': '8',
  '€ je m²': '9',
  '€ je m2': '9',
  'je 1.000 Einwohner': '10',
  'je 10.000 Einwohner': '11',
  'je 100.000 Einwohner': '12',
  'km² je 1.000 Einwohner': '13',
  'km2 je 1.000 Einwohner': '13',
  'l je Einwohner und Tag': '14',
  't je Einwohner': '15',
  kategorial: '99',
};

export const unitsAsArray = () => {
  return Object.values(units);
};
